// import { load } from "@shopify/theme-sections"
// import "../sections/product"

// load("*")

/* eslint-disable no-undef */
/* eslint-disable no-console */
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import { getUrlWithVariant, ProductForm } from "@shopify/theme-product-form";
import { formatMoney } from "@shopify/theme-currency";
import { register } from "@shopify/theme-sections";
import { forceFocus } from "@shopify/theme-a11y";

import Dispatcher from "../ui/core/dispatcher-flyd";

const classes = {
  hide: "hide",
};

const keyboardKeys = {
  ENTER: 13,
};

const selectors = {
  inquireButton: "[data-product-inquire]",
  submitButton: "[data-submit-button]",
  submitButtonText: "[data-submit-button-text]",
  comparePrice: "[data-compare-price]",
  comparePriceText: "[data-compare-text]",
  priceWrapper: "[data-price-wrapper]",
  imageWrapper: "[data-product-image-wrapper]",
  visibleImageWrapper: `[data-product-image-wrapper]:not(.${classes.hide})`,
  imageWrapperById: (id) => `${selectors.imageWrapper}[data-image-id='${id}']`,
  productForm: "[data-product-form]",
  productPrice: "[data-product-price]",
  thumbnail: "[data-product-single-thumbnail]",
  thumbnailById: (id) => `[data-thumbnail-id='${id}']`,
  thumbnailActive: "[data-product-single-thumbnail][aria-current]",
};

// console.warn("here: found form?", document.querySelector(selectors.productForm))
// console.warn(`register:`, register)

register("product", {
  async onLoad() {

    const productFormElement = document.querySelector(selectors.productForm);

    this.product = await this.getProductJson(
      productFormElement.dataset.productHandle
    );

    this.productForm = new ProductForm(productFormElement, this.product, {
      onOptionChange: this.onFormOptionChange.bind(this),
      onQuantityChange: this.onFormOptionChange.bind(this),
    });

    this.onThumbnailClick = this.onThumbnailClick.bind(this);
    this.onThumbnailKeyup = this.onThumbnailKeyup.bind(this);

    this.container.addEventListener("click", this.onThumbnailClick);
    this.container.addEventListener("keyup", this.onThumbnailKeyup);

    Dispatcher.dispatch({
      type: "products-loaded"
    });
  },

  onUnload() {
    this.productForm.destroy();
    this.removeEventListener("click", this.onThumbnailClick);
    this.removeEventListener("keyup", this.onThumbnailKeyup);
  },

  getProductJson(handle) {
    return fetch(`/products/${handle}.js`).then((response) =>
      response.json()
    );
  },

  onFormOptionChange(event) {
    // console.log(`onFormOptionChange called`)

    const { variant } = event.dataset;

    console.warn('onFormOptionChange: event.dataset:', {... event.dataset})
    this.renderPrice(variant, event.dataset.quantity);

    this.renderImages(variant);
    this.renderComparePrice(variant);
    this.renderSubmitButton(variant);

    this.updateBrowserHistory(variant);
  },

  onThumbnailClick(event) {
    const thumbnail = event.target.closest(selectors.thumbnail);

    if (!thumbnail) {
      return;
    }

    event.preventDefault();

    this.renderFeaturedImage(thumbnail.dataset.thumbnailId);
    this.renderActiveThumbnail(thumbnail.dataset.thumbnailId);
  },

  onThumbnailKeyup(event) {
    if (
      event.keyCode !== keyboardKeys.ENTER ||
      !event.target.closest(selectors.thumbnail)
    ) {
      return;
    }

    const visibleFeaturedImageWrapper = this.container.querySelector(
      selectors.visibleImageWrapper
    );

    forceFocus(visibleFeaturedImageWrapper);
  },

  renderSubmitButton1(variant) {
    const submitButton = this.container.querySelector(selectors.submitButton);
    const submitButtonText = this.container.querySelector(
      selectors.submitButtonText
    );
    if (!variant) {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.unavailable;
    } else if (variant.available) {
      submitButton.disabled = false;
      submitButtonText.innerText = theme.strings.addToCart;
    } else {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.soldOut;
    }
  },

  renderSubmitButton(variant) {
    // console.log(`renderSubmitButton called`)
    // console.log(`variant`, {... variant})

    const submitButton = this.container.querySelector(selectors.submitButton);
    const submitButtonText = this.container.querySelector(
      selectors.submitButtonText
    );
    const inquireButton = this.container.querySelector(selectors.inquireButton);

    // const displayClass = submitButton.hasClass(`df`) ? `df` : `db`
    const displayClass = `df`

    const price = this.container.querySelector(`[data-price-wrapper]`)
    // console.log(`price`, price)
    // submitButton.addClass(`db`);
    // submitButton.removeClass(`dn`);

    // if (inquireButton != null) {
    //   inquireButton.addClass(`dn`);
    // }

    if (!variant) {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.unavailable;
    } else if (variant.available) {
      // console.log(`add to cart`)
      submitButton.disabled = false;
      submitButtonText.innerText = theme.strings.addToCart;

      price.removeClass(`dn`);
      submitButton.removeClass(`dn`);
      submitButton.removeClass(`db`);
      submitButton.addClass(displayClass);

      if (inquireButton != null) {
        //   submitButton.addClass(`dn`);

          inquireButton.removeClass(`db`);
          inquireButton.addClass(`dn`);
          // inquireButton.href = `mailto:orders@erbutler.com?subject=${variant.name}`;
        }
    } else {
      // console.log(`sold out`)
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.soldOut;

      submitButton.removeClass(displayClass);
      submitButton.addClass(`dn`);
      price.addClass(`dn`);
      // console.log(`inquire is null?`, inquireButton == null)
      if (inquireButton != null) {
      //   submitButton.addClass(`dn`);

        inquireButton.removeClass(`dn`);
        inquireButton.addClass(`db`);
        inquireButton.href = `mailto:orders@erbutler.com?subject=${variant.name}`;
      }
    }
  },

  renderImages(variant) {
    if (!variant || variant.featured_media === undefined) {
      return;
    }

    Dispatcher.dispatch({
      type: "show-panel-image",
      id: variant.featured_media.id,
    });
  },

  renderPrice(variant, quantity) {
    console.log(`renderPrice: variant`, variant)
    console.log(`renderPrice: quantity ${quantity}`)

    const priceElement = this.container.querySelector(selectors.productPrice);
    const priceWrapperElement = this.container.querySelector(
      selectors.priceWrapper
    );

    priceWrapperElement.classList.toggle(classes.hide, !variant);

    if (variant) {
      priceElement.innerText = formatMoney(
        variant.price * quantity,
        theme.moneyFormat
      );
    }
  },

  renderComparePrice(variant) {
    if (!variant) {
      return;
    }

    const comparePriceElement = this.container.querySelector(
      selectors.comparePrice
    );
    const compareTextElement = this.container.querySelector(
      selectors.comparePriceText
    );

    if (!comparePriceElement || !compareTextElement) {
      return;
    }

    if (variant.compare_at_price > variant.price) {
      comparePriceElement.innerText = formatMoney(
        variant.compare_at_price,
        theme.moneyFormat
      );
      compareTextElement.classList.remove(classes.hide);
      comparePriceElement.classList.remove(classes.hide);
    } else {
      comparePriceElement.innerText = "";
      compareTextElement.classList.add(classes.hide);
      comparePriceElement.classList.add(classes.hide);
    }
  },

  renderActiveThumbnail(id) {
    const activeThumbnail = this.container.querySelector(
      selectors.thumbnailById(id)
    );
    const inactiveThumbnail = this.container.querySelector(
      selectors.thumbnailActive
    );

    if (activeThumbnail === inactiveThumbnail) {
      return;
    }

    inactiveThumbnail.removeAttribute("aria-current");
    activeThumbnail.setAttribute("aria-current", true);
  },

  renderFeaturedImage(id) {
    const activeImage = this.container.querySelector(
      selectors.visibleImageWrapper
    );
    const inactiveImage = this.container.querySelector(
      selectors.imageWrapperById(id)
    );

    activeImage.classList.add(classes.hide);
    inactiveImage.classList.remove(classes.hide);
  },

  updateBrowserHistory(variant) {
    const { enableHistoryState } = this.productForm.element.dataset;

    if (!variant || enableHistoryState !== "true") {
      return;
    }

    const url = getUrlWithVariant(window.location.href, variant.id);
    window.history.replaceState({ path: url }, "", url);
  },
});
